let search_btn = document.querySelector('.tap-area.mobsearchbar_hide');
if (window.innerWidth < 768) {
  search_btn = document.querySelector('.header__icon-list > a');
}

if (search_btn) {
  search_btn.addEventListener('click', function () {

    setTimeout(() => {
      let wiz_search = document.querySelector('.search-input > input');
      if (wiz_search) {
        wiz_search.click();
      }
setTimeout(() => {
         const drawer = document.querySelector("search-drawer");
const wizzyWrapper = document.querySelector(".wizzy-body-end-wrapper");
if (drawer && wizzyWrapper) {

  drawer.appendChild(wizzyWrapper); 
}
}, 1000);

    }, 500);


  });
}




// if(window.innerWidth < 768)
// {
//   let search_btn = document.querySelector('a.tap-area');
//   if(search_btn)
//   {
//     search_btn.addEventListener('click', function(){
//       setTimeout(() => {
//         let wiz_search = document.querySelector('.wizzy-search-input');
//         if(wiz_search)
//         {
//           wiz_search.click();
//         }
//       }, 300);
//     })
//   }
// }

// let search_bar = document.querySelector('.search-drawer');
// if (search_bar) {
//   search_bar.addEventListener('toggle', (e) => {
//          console.log("in toggle");
//     let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
//     if(autocomplete && getComputedStyle(autocomplete).display === "flex")
//     {
//       if (!search_bar.open) {
//         search_bar.setAttribute("open","");
//       }
//     }
    
//   });
// }

// document.addEventListener("click", function (event) {
//   const input = event.target.closest(".search-drawer .search-input input");
//   if (!input) return;

//   setTimeout(() => {
//     const target = document.querySelector(".wizzy-autocomplete-wrapper.onLeft");
//     const header = document.querySelector("body");

//     if (!target || !header) return;

//     const checkAndApplyClass = () => {
//       const display = getComputedStyle(target).display;
//       if (display === "flex") {
//         header.classList.add("wizzy-autocomplete-opened");
//         input.style.clipPath = "none"; 
//          target.click();
//         console.log("Clicked on autocomplete");
//       } else {
//         header.classList.remove("wizzy-autocomplete-opened");
//       }
//     };

//     checkAndApplyClass();

//     const observer = new MutationObserver((mutationsList) => {
//       for (const mutation of mutationsList) {
//         if (mutation.attributeName === "style") {
//           checkAndApplyClass();
//         }
//       }
//     });

//     observer.observe(target, {
//       attributes: true,
//       attributeFilter: ["style"],
//     });

//   }, 500);
// });



const closeButton = document.querySelector('.search-drawer button[is="close-button"]');
if(closeButton)
{
  closeButton.addEventListener("click", function(e){
    e.preventDefault();
    const header = document.querySelector('body');
    const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if(autocomplete)
    autocomplete.style.setProperty("display", "none", "important");
    header.classList.remove("wizzy-autocomplete-opened");
  })
}

window.onWizzyScriptLoaded = function () {
        window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.common.lazyDOMConfig.contentDOMIdentifiers=['body main']
// window.wizzyConfig.search.configs.pagination.appendInExistingList = true;

      return data;
    }
  );
      window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
     data.common.lazyDOMConfig.searchInputIdentifiers = ['.search-input'];
         data.filters.configs.keepOpenedInMobileAfterApply = true;

      return data;
    }
  );
  

  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (data) {
    if(document.querySelector('.search-input .icon.icon-close')){
    const  icon = document.querySelector('.search-input .icon.icon-close').closest('button').click();
    if(icon ) {
      const closestEle = icon.closest('button');
      if(closestEle) {
        closestEle.click();
      }
    }
    }
return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
   products.forEach((product)=>{
    product.attributes.forEach((attr)=>{
   if(attr.id === "product_handle"){
      product.handle=attr.values[0].value[0];
    }
    if(attr.id === "product_badges_custom"){
     if(attr.values[0].value[0] === "New Launch"){
      product.newlaunch=true;
     }

  if(attr.values[0].value[0] === "Reed Diffuser Set"){
      product.Reed_Diffuser_Set=true;
     }

    }
    
     
        if(attr.id === "product_badge_judgeme"){
      product.judgemeReviews=attr.values[0].value[0];
    }
   })
 let sellingprice = product.sellingPrice;
          sellingprice = sellingprice.replace(/,/g, ""); 
          sellingprice = parseInt(sellingprice, 10);
          product.whistlistsellprice = sellingprice;
   });

  return products;
  });

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (data) {
    window.WH_TimeOutForCustomButtonsDetection = 500;

    document.querySelectorAll(".wishlist-hero-custom-button").forEach(function (item) {
      const event = new CustomEvent("wishlist-hero-add-to-custom-element", {
        detail: item,
      });
      document.dispatchEvent(event);
    });

    return data;
  }
);
const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());

}
if (window.innerWidth < 768) {
  const searchBar = document.querySelector(
    ".search-input .wizzy-search-input"
  );
  if (searchBar) {
    searchBar.addEventListener("click", () => {
      setTimeout(() => {
        let autoCompleteArrows = document.querySelectorAll(
          ".autocomplete-text-wrapper"
        );
        if (autoCompleteArrows) {
          autoCompleteArrows.forEach((arrow) => {
            if (arrow) {
              arrow.addEventListener("click", () => {
                arrow.click();
                arrow.click();
                searchBar.blur();
                // console.log("clicked on arrow");
                searchBar.value =
                  arrow.parentElement.getAttribute("data-searchterm");
                searchBar.focus();
                // console.log(arrow.parentElement.getAttribute("data-searchterm"));
              });
            }
          });
        }
      }, 500);
  
      // let modalOverlay = document.querySelector(".modal-overlay");
      // modalOverlay.forEach((modal)=>{
      //   modal.addEventListener("click",()=>{
      //     let searchCloseButton =
      //   })
      // })
    });
  }
}
   


